define( [ 'utility' ], function run( utility ) {
	'use strict';

	var mRadioSegmentedFn = {

		init : function( elm ) {
			var onResize,
				onRefresh;

			if ( !elm.classList.contains( 'js-m-radio-segmented' ) ) {
				elm.classList.add( 'm-radio-segmented' );
				elm.classList.add( 'js-m-radio-segmented' );

				elm.mRadioSegmented = {}; // Setup mRadioSegmented object
				elm.mRadioSegmented.breakpoint = utility.getBreakpoint();
				elm.mRadioSegmented.radioGroupItems = elm.querySelectorAll( '.m-form-row-group-item' );

				elm.append( utility.htmlStringToElement( '<li class="m-radio-segmented__ui" aria-hidden="true"></li>' ) );
				elm.mRadioSegmented.sliderUI = elm.querySelector( '.m-radio-segmented__ui' );
				elm.mRadioSegmented.radioInputs = Array.prototype.slice.call( elm.querySelectorAll( '.a-radio__input' ) ); // Convert to array so can later use indexOf

				elm.mRadioSegmented.radioInputs.forEach( function loop( radioInput ) {
					radioInput.addEventListener( 'change', function listener() {
						mRadioSegmentedFn.updateChecked( elm );
					});
					radioInput.addEventListener( 'focus', function listener() {
						elm.classList.add( 'has-focus' );
					});
					radioInput.addEventListener( 'focusout', function listener() {
						elm.classList.remove( 'has-focus' );
					});
				});

				elm.mRadioSegmented.windowWidth = window.innerWidth;

				onResize = utility.debounce( function listener() {
					var newWindowWidth = window.innerWidth;
					if ( newWindowWidth !== elm.mRadioSegmented.windowWidth ) {
						elm.mRadioSegmented.windowWidth = newWindowWidth;
						elm.mRadioSegmented.breakpoint = utility.getBreakpoint();
						elm.mRadioSegmented.sliderUI.style.transition = 'none';
						mRadioSegmentedFn.shortLabel( elm );
						mRadioSegmentedFn.positionSlider( elm );
					}
				}, 10 );

				onRefresh = utility.debounce( function listener() {
					if ( utility.isVisible( elm ) ) {
						elm.mRadioSegmented.sliderUI.style.transition = 'none';
						mRadioSegmentedFn.shortLabel( elm );
						mRadioSegmentedFn.positionSlider( elm );
					}
				}, 10 );

				window.addEventListener( 'resize', onResize );
				window.addEventListener( 'refresh', onRefresh );

				mRadioSegmentedFn.shortLabel( elm );
				mRadioSegmentedFn.updateChecked( elm );

				elm.mRadioSegmented.clear = function clear() {
					var currentChecked = elm.querySelector( '.a-radio__input:checked' );
					if ( currentChecked ) {
						// If there is currently an option checked, uncheck and then force the control to update
						currentChecked.checked = false;
						mRadioSegmentedFn.updateChecked( elm );
					}
				};

				elm.mRadioSegmented.select = function select( inputId ) {
					var inputElm = elm.querySelector( '.a-radio__input' + inputId );
					if ( inputElm ) {
						// If there is currently an option checked, uncheck and then force the control to update
						inputElm.checked = true;
						mRadioSegmentedFn.updateChecked( elm );
					}
				};
			}

			return elm.mRadioSegmented;
		},

		updateChecked : function( elm ) {
			elm.mRadioSegmented.radioGroupItems.forEach( function loop( radioItem ) {
				radioItem.classList.remove( 'is-checked' );
			});
			elm.mRadioSegmented.checkedElement = elm.querySelector( '.a-radio__input:checked' );

			utility.removeClass( elm, 'js-m-radio-segmented-checked js-m-radio-segmented-checked--1 js-m-radio-segmented-checked--2 ' +
				'js-m-radio-segmented-checked--3 js-m-radio-segmented-checked--4 js-m-radio-segmented-checked--5' );
			if ( elm.mRadioSegmented.checkedElement ) {
				elm.classList.add( 'js-m-radio-segmented-checked' );
				elm.classList.add( 'js-m-radio-segmented-checked--' + ( elm.mRadioSegmented.radioInputs.indexOf( elm.mRadioSegmented.checkedElement ) + 1 ) );
				elm.mRadioSegmented.checkedElement = elm.mRadioSegmented.checkedElement.closest( '.m-form-row-group-item' );
				elm.mRadioSegmented.checkedElement.classList.add( 'is-checked' );
			}

			mRadioSegmentedFn.positionSlider( elm );
		},

		positionSlider : function( elm ) {
			if ( elm.mRadioSegmented.breakpoint === utility.smallTag && !elm.classList.contains( 'm-radio-segmented--short-label' ) && elm.mRadioSegmented.checkedElement ) {
				setTimeout( function timeoutFn() {
					elm.mRadioSegmented.sliderUI.removeAttribute( 'style' );
					elm.mRadioSegmented.sliderUI.style.height = utility.convertToPx( elm.mRadioSegmented.checkedElement.offsetHeight );
					elm.mRadioSegmented.sliderUI.style.top = utility.convertToPx( elm.mRadioSegmented.checkedElement.offsetTop );
				}, 50 );
			} else {
				setTimeout( function timeoutFn() {
					elm.mRadioSegmented.sliderUI.removeAttribute( 'style' );
				}, 50 );
			}
		},

		getPadding : function( element ) {
			var styles = window.getComputedStyle( element );
			return Number.parseInt( styles.paddingLeft, 10 ) + Number.parseInt( styles.paddingRight, 10 );
		},

		shortLabel : function( elm ) {
			var tempLi,
				tempSpan,
				tempLiWidth,
				elmWidth,
				paddingWidth;

			if ( !elm.classList.contains( 'm-form-row-group--pictorial' ) ) {
				elm.classList.remove( 'm-radio-segmented--short-label' );

				tempLi = utility.htmlStringToElement( '<li class="a-radio"><span class="a-radio__label">' + elm.textContent + '</span></li>' );
				tempSpan = tempLi.querySelector( '.a-radio__label' );

				elm.append( tempLi );

				tempLiWidth = tempLi.clientWidth + ( mRadioSegmentedFn.getPadding( tempSpan ) * 2 );

				paddingWidth = 0;
				elm.querySelectorAll( '.a-radio__label' ).forEach( function loop( thisLabel ) {
					paddingWidth += mRadioSegmentedFn.getPadding( thisLabel );
				});

				elmWidth = elm.clientWidth - paddingWidth;
				if ( tempLiWidth < elmWidth ) {
					elm.classList.add( 'm-radio-segmented--short-label' );
				}
				tempLi.remove();
			}
		},
	};

	return {
		initInstance : function( el ) {
			return mRadioSegmentedFn.init( el );
		},
	};
});
